import { render, staticRenderFns } from "./GestioneSchedeHyroxAdmin.vue?vue&type=template&id=93bd4046&"
import script from "./GestioneSchedeHyroxAdmin.vue?vue&type=script&lang=js&"
export * from "./GestioneSchedeHyroxAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports